module.exports = __webpack_public_path__ + "media/addons/SecurityProtection-0c5514c7.svg";